import { AgendaDaysToShow } from '@repo/lib/constants/calendar-constants';
import { VIEW_KEY } from '@repo/types/enums/viewKey';
import { addDays, endOfDay, endOfMonth, endOfWeek, startOfDay, startOfMonth, startOfWeek } from 'date-fns';
import { useCallback, useMemo } from 'react';

export interface EventCalendarRangeDates {
  after: string;
  before: string;
}
export function useEventCalendarRangeDates(currentDate: Date, view: VIEW_KEY): EventCalendarRangeDates {
  const getStartDate = useCallback(() => {
    if (view === VIEW_KEY.DAY) {
      return startOfDay(currentDate).toISOString();
    }
    if (view === VIEW_KEY.WEEK) {
      return startOfWeek(currentDate).toISOString();
    }
    if (view === VIEW_KEY.MONTH) {
      const monthStart = startOfMonth(currentDate);
      return startOfWeek(monthStart).toISOString();
    }
    return startOfDay(currentDate).toISOString();
  }, [currentDate, view]);
  const getEndDate = useCallback(() => {
    if (view === VIEW_KEY.DAY) {
      return endOfDay(currentDate).toISOString();
    }
    if (view === VIEW_KEY.WEEK) {
      return endOfWeek(currentDate).toISOString();
    }
    if (view === VIEW_KEY.MONTH) {
      const monthEnd = endOfMonth(currentDate);
      return endOfWeek(monthEnd).toISOString();
    }
    return endOfDay(addDays(startOfMonth(currentDate), AgendaDaysToShow)).toISOString();
  }, [currentDate, view]);

  return useMemo(() => {
    return {
      after: getStartDate(),
      before: getEndDate(),
    };
  }, [view, currentDate]);
}
